var map = {
	"./demos/asyncClose/index.ts": 38736,
	"./demos/basic/index.ts": 6463,
	"./demos/block/index.ts": 43815,
	"./demos/destroy/index.ts": 66285,
	"./demos/events/index.ts": 65889,
	"./demos/overlay/index.ts": 81183,
	"./demos/size/index.ts": 4162,
	"./demos/static/index.ts": 74542,
	"./demos/terminate/index.ts": 16362
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31798;